




































import { defineComponent, PropType } from '@vue/composition-api';
import { ChatBase } from '@ligo/shared/utils';
import { AppLink } from '@ligo/shared/components';
import { CalculatorBasicField, getI18n } from '@ligo/bv-flow/store';

export default defineComponent({
  components: {
    AppLink
  },
  props: {
    field: {
      type: Object as PropType<CalculatorBasicField<any>>,
      required: true
    },
    fieldKey: String
  },
  setup(props) {
    function launchChatBase() {
      ChatBase.openWidget();
    }

    const label = getI18n(props.field, 'label');
    const subtitle = getI18n(props.field, 'subtitle');

    return { launchChatBase, label, subtitle };
  }
});
